import { render, staticRenderFns } from "./XeroAuthorizeSuccess.vue?vue&type=template&id=2ab5987d&scoped=true&"
import script from "./XeroAuthorizeSuccess.vue?vue&type=script&lang=js&"
export * from "./XeroAuthorizeSuccess.vue?vue&type=script&lang=js&"
import style0 from "./XeroAuthorizeSuccess.vue?vue&type=style&index=0&id=2ab5987d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab5987d",
  null
  
)

export default component.exports